import {createRoot, hydrateRoot} from 'react-dom/client';
import SingleTeamMemberTemplate from '../pages/SingleTeamMemberTemplate/SingleTeamMemberTemplate'
import "../index.css";
import "../pages/SingleTeamMemberTemplate/SingleTeamMemberTemplate.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<SingleTeamMemberTemplate {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <SingleTeamMemberTemplate {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).SingleTeamMemberTemplateVC = {mount, hydrate, unmount}